import { render, staticRenderFns } from "./loading-screen.vue?vue&type=template&id=78c9585f&scoped=true"
import script from "./loading-screen.vue?vue&type=script&setup=true&lang=ts"
export * from "./loading-screen.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./loading-screen.vue?vue&type=style&index=0&id=78c9585f&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9585f",
  null
  
)

export default component.exports